import { SvgIcon, type SvgIconProps } from '@mui/material'

export const QuoteIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="1em" height="1em" style={{ fontSize: '2rem' }} viewBox="0 0 38 38" fill="none" {...props}>
    <path
      d="M1.53662 35V36.5H3.03662H16.6532H18.1532V35V21.5855V20.0855H16.6532H12.1734L17.5337 16.1992L18.1532 15.75V14.9848V7V3.94206L15.735 5.81383L2.11847 16.3538L1.53662 16.8041V17.5399V35ZM19.3347 35V36.5H20.8347H34.4513H35.9513V35V21.5855V20.0855H34.4513H29.9715L35.3317 16.1992L35.9513 15.75V14.9848V7V3.94206L33.5331 5.81383L19.9165 16.3538L19.3347 16.8041V17.5399V35Z"
      fill="#D2F070"
      stroke="#004D3B"
      style={{
        fill: '#D2F070',
        fillOpacity: 1,
        stroke: '#004D3B',
        strokeOpacity: 1,
      }}
      strokeWidth="3"
    />
  </SvgIcon>
)
